import Link from "next/link"
import { Routes } from "../routes"

export const states = [
   "AL",
   "AK",
   "AZ",
   "AR",
   "CA",
   "CO",
   "CT",
   "DE",
   "FL",
   "GA",
   "HI",
   "ID",
   "IL",
   "IN",
   "IA",
   "KS",
   "KY",
   "LA",
   "ME",
   "MD",
   "MA",
   "MI",
   "MN",
   "MS",
   "MO",
   "MT",
   "NE",
   "NV",
   "NH",
   "NJ",
   "NM",
   "NY",
   "NC",
   "ND",
   "OH",
   "OK",
   "OR",
   "PA",
   "RI",
   "SC",
   "SD",
   "TN",
   "TX",
   "UT",
   "VT",
   "VA",
   "WA",
   "WV",
   "WI",
   "WY",
]

export const content = {
   title: "Become a member of the Restaurant Association!",
   details: "Unlock exclusive access to webinars, events, and the latest news for FREE! ",
   disclaimer: [
      `By clicking below, I acknowledge and agree to Restaurant Association's `,
      <Link href={Routes.client.termsAndConditions.getPath()} className="text-brandOrange" key={"terms-of-service"}>
         Terms of Service
      </Link>,
      ` and to Restaurant Association's use of my contact information to communicate with me about Restaurant Association's or its third party partners' products, services, events and research opportunities. Restaurant Association's use of the information I provide will be consistent with Restaurant Association's `,
      <Link href={Routes.client.privacyPolicy.getPath()} className="text-brandOrange" key="privacy-policy">
         Privacy Policy
      </Link>,
   ],
   form: {
      operationsOptions: [
         "Chain Restaurant/Foodservice Operation",
         "Independent Restaurant/Foodservice Operation",
         "FS Contract Management",
         "Non-Commercial Establishment (Self-op, university, hospital, etc)",
         "Student in Foodservice/Hospitality",
         "Distributors",
         "Manufacturer",
         "Equipment Dealer/Specialty Distributor",
         "Architect/Designer",
         "Consultant",
         "Technology Company",
         "Financial Company",
         "Real Estate Firm",
         "Library/Government (Non-Foodservice)",
         "Marketing Firm",
         "Advertising/PR Agency",
         "Media/Communications Firm",
         "Research Firm",
         "Other",
      ],
      descriptionOptions: [
         "Casual or Theme",
         "Family",
         "Quick Service/Fast Food",
         "Fast Casual",
         "Fine Dining",
         "Cafeteria/Buffet",
         "Drinking Place (Tavern, bar)",
         "Foodservice in a store/Supermarket/C-Store",
         "Recreational Facility",
         "Hotel/Motel/Resort/Spa",
         "Contractor/Foodservice Management",
         "Hospital/Healthcare",
         "Nursing Home/Retirement/Lifecare",
         "Primary/Secondary School",
         "College/University",
         "B&I",
         "Food Vending/Mobile Caterer",
         "Central Commissary",
         "Clubs (excluding Military)",
         "Social Caterer",
         "In-transit Feeding",
         "Other Establishment",
         "Not Applicable",
      ],
   },
}
